import gql from 'graphql-tag';

const printProductSizeBaseDetails = gql`
  fragment printProductSizeBaseDetails on PrintProductSize {
    id
    print_size {
      id
      name
    }
    orientations
    mounts {
      total
    }
    total_price {
      value
      currency
    }
    roes_info {
      image_nodes {
        id
        ui_description
        ui_label
        bounds
        is_required
      }
      text_nodes {
        id
        ui_description
        ui_label
        bounds
        is_required
        default_text
      }
    }
    preview_asset_image {
      id
      url
    }
  }
`;

export default printProductSizeBaseDetails;
